import React, { useState } from "react";

const ReadMoreText = ({ text, maxLength, shouldExpand = true }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (text.length <= maxLength) {
    return <p>{text}</p>;
  }

  return (
    <div className="notification-summary-message">
      <p>
        {isExpanded ? text : `${text.substring(0, maxLength).trim()}... `}
        <label
          onClick={() => {
            if (shouldExpand) setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </label>
      </p>
    </div>
  );
};

export default ReadMoreText;
